import { useGetMany } from 'react-admin';
import { MerchantAccess } from 'types/embedded/merchantAccess';

export const useMerchantAccesses = (merchantAccessesIds?: string[]) => {
  const query = useGetMany<MerchantAccess>(
    'merchant_accesses',
    { ids: merchantAccessesIds },
    { enabled: !!merchantAccessesIds?.length },
  );

  return {
    merchantAccesses: query.data,
    isLoading: query.isLoading,
  };
};
